/**
 * @generated SignedSource<<c4e67c260123247f7124572fc8266d82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicSharpFlatNatural = "FLAT" | "NATURAL" | "SHARP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural$data = {
  readonly id: string;
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly type: MusicSharpFlatNatural;
  readonly finder_confidence: number;
  readonly placement: number | null;
  readonly " $fragmentType": "NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural";
};
export type NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural$key = {
  readonly " $data"?: NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "x",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "y",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finder_confidence",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "placement",
      "storageKey": null
    }
  ],
  "type": "MusicParseStepDataNoteDataSourceCombineSharpFlatNatural",
  "abstractKey": null
};

(node as any).hash = "de6ebd175ede38a6165b61b5f0b6c5c7";

export default node;
